export const content = {
  suggestionHeading: "HELP ARTICLES",
  noResultsTemplate: (query: string) =>
    `We couldn't find any results for "${query}".`,
  noResultsRetry: "Try again with a different search term.",
  noResultsImageUrl:
    "https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/Disabled/pictogram_browser_search_disabled.svg",
};
